import { Grid } from '@material-ui/core';
import useText from 'constants/text';
import { NewRequestQuoteContext } from 'contexts/RequestQuoteContext';
import React from 'react'
import { useStyles } from '../shared/NTSideRecap';
import SchedulingDetails from '../shared/RightSideComponents/components/SchedulingDetails';
import NTCollipsableStops from './Collapse';

const RecapNt = () => {
  const { requestQuoteNT,requestQuoteDetails, setStep } = React.useContext(NewRequestQuoteContext);
  const { text } = useText();
  const styles = useStyles();
  React.useEffect(() => {
    setStep(3)
  })

  return (

    <Grid container spacing={1} className={styles.gridContainer}>
      <Grid item xs={12} style={{ paddingRight: '14px' }}>
        <Grid item xs={12} className={styles.gridStyle}>
          Vehicles/stop
          <hr className={styles.hr} />
        </Grid>
        <Grid item xs={12}>
          <NTCollipsableStops requestQuoteNT={requestQuoteNT || requestQuoteDetails} />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {requestQuoteNT?.productType?.length ? (
          <Grid item xs={12}>
            <SchedulingDetails requestToDisplay={requestQuoteNT} isDisabled />
          </Grid>
        ):(
          <Grid item xs={12}>
            <SchedulingDetails requestToDisplay={requestQuoteDetails} isDisabled />
          </Grid>
        )}
        {requestQuoteNT?.additionnalInfos ? (
          <>
            <Grid item xs={12} className={styles.gridStyle}>
              {text.all.additional_infos}
              <hr className={styles.hr3} />
            </Grid>
            <Grid item xs={12}>
              <p className={styles.p}>{requestQuoteNT?.additionnalInfos}</p>
            </Grid>
          </>
        ):(
          <>
            <Grid item xs={12} className={styles.gridStyle}>
              {text.all.additional_infos}
              <hr className={styles.hr3} />
            </Grid>
            <Grid item xs={12}>
              <p className={styles.p}>{requestQuoteDetails?.additionnalInfos}</p>
            </Grid>
          </>
        )}
      </Grid>
    </Grid >

  )
}

export default RecapNt
